import { log } from "../../shared/services/debug-logger";
import { api, apiUrl } from "../../shared/services/service";
import type { VoyageInfo, VoyageRealtimeStatusResponse } from "../models/voyage.interfaces";

export async function getRealtimeInfo(tcCode: string | undefined, voyageNo: string | undefined) {
  const result = await api.get<VoyageRealtimeStatusResponse[]>(`${apiUrl}/voyageRealtimeStatus`, {
    params: {
      tc_code: tcCode,
      voyage_no: voyageNo,
    },
  });
  log("REPO - getRealtimeInfo - response", { status: result.status });
  return result.data[0]?.REAL_TIME_VOYAGE_STATUS;
}

export async function getVoyageItinerary(tcCode: string | undefined, voyageNo: string | undefined) {
  const result = await api.get(`${apiUrl}/voyageItinerary`, {
    params: {
      tc_code: tcCode,
      voyage_no: voyageNo,
    },
  });
  log("REPO - getVoyageItinerary - response", { count: result.data?.length ?? 0 });
  return result.data;
}

export async function getVoyageCargoDetails(tcCode: string | undefined, voyageNo: string | undefined) {
  const result = await api.get(`${apiUrl}/voyageCargoDetails`, {
    params: {
      tc_code: tcCode,
      voyage_no: voyageNo,
    },
  });
  return result.data;
}

export async function getVoyageSequenceItinerary(
  tcCode: string | undefined,
  voyageNo: string | undefined,
): Promise<VoyageInfo[]> {
  log("REPO - getVoyageSequenceItinerary", { tcCode, voyageNo });
  const result = await api.get(`${apiUrl}/voyageSequenceItinerary`, {
    params: {
      tc_code: tcCode,
      voyage_no: voyageNo,
    },
  });
  log("REPO - getVoyageSequenceItinerary - response", { count: result.data?.length ?? 0 });
  return result.data;
}
